import { GamePhase } from '../../../domain/entities/GamePhase';
export class InMemoryGamePhaseRepository {
    constructor() {
        this.currentGamePhase = GamePhase.NONE;
    }
    changeGamePhase(gamePhase) {
        this.currentGamePhase = gamePhase;
        return Promise.resolve();
    }
    retrieveCurrentGamePhase() {
        return Promise.resolve(this.currentGamePhase);
    }
}
